export default __webpack_public_path__ + "static/media/armguards_of_the_wicked.cf2ec7f1.jpg";